import { render, staticRenderFns } from "./EmergencySelector.vue?vue&type=template&id=822f610a&scoped=true&"
import script from "./EmergencySelector.vue?vue&type=script&lang=js&"
export * from "./EmergencySelector.vue?vue&type=script&lang=js&"
import style0 from "./EmergencySelector.vue?vue&type=style&index=0&id=822f610a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "822f610a",
  null
  
)

export default component.exports